import React from 'react';
import { useLocation, useHistory, Switch, Route } from 'react-router-dom';
import { PageContainer } from '@ant-design/pro-layout';
import { Main } from 'components/layout';
import NewProjectApplications from './NewProjectApplications';
import MyProjectApplications from './MyProjectApplications';
import AllProjectApplications from './AllProjectApplications';

const tabList = [
  {
    key: 'fundings',
    tab: 'Funding opportunities',
  },
  {
    key: 'my',
    tab: 'My applications',
  },
  {
    key: 'all',
    tab: 'Applications under my purview',
  },
];

const ProjectApplications = () => {
  const history = useHistory();
  const { pathname } = useLocation();

  const handleTabChange = (key) => {
    history.push(`/project-applications/${key}`);
  };

  const getTabKey = () => {
    const tabKey = pathname.split('/')[2];
    return tabKey;
  };

  return (
    <Main>
      <PageContainer
        header={{ title: 'Funding for Teaching Development' }}
        ghost
        onTabChange={handleTabChange}
        tabActiveKey={getTabKey()}
        tabList={tabList}
      >
        <Switch>
          <Route
            exact
            path="/project-applications/my"
            component={MyProjectApplications}
          />
          <Route
            exact
            path="/project-applications/fundings"
            component={NewProjectApplications}
          />
          <Route
            exact
            path="/project-applications/all"
            component={AllProjectApplications}
          />
        </Switch>
      </PageContainer>
    </Main>
  );
};

export default ProjectApplications;
